import { Icon, IconProps } from './Icon';

export type DialogProps = IconProps;

const Dialog = (props: DialogProps) => (
  <Icon fill="none" viewBox="0 0 15 13" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15 1.068v8.197c0 .589-.559 1.069-1.243 1.069h-6.98L3.712 12.86a.49.49 0 0 1-.164.103.557.557 0 0 1-.199.036c-.267 0-.485-.187-.485-.417v-2.25h-1.62C.561 10.334 0 9.853 0 9.266V1.068C0 .486.564 0 1.243 0h12.514C14.438 0 15 .483 15 1.068zM3.543 6.612c-.268 0-.485-.201-.485-.45 0-.25.217-.451.485-.451h6.705c.267 0 .484.202.484.45 0 .25-.217.451-.484.451zm0-2.703c-.268 0-.485-.202-.485-.451s.217-.45.485-.45h8.221c.268 0 .485.201.485.45 0 .25-.217.45-.485.45z"
      clipRule="evenodd"
    />
  </Icon>
);

export { Dialog };
